import { ModelOutputDocument } from 'types';

import { api } from './api';

export const genaiApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDocumentExtract: build.query<ModelOutputDocument, string>({
      query: (documentId) => ({
        url: `genai/documents/${documentId}/extract`,
      }),
      providesTags: (_result, _error, documentId) => [{ type: 'ModelOutputs', id: documentId }],
    }),
    getDocumentExtractsByAccount: build.query<ModelOutputDocument[], string>({
      query: (accountId) => ({
        url: `genai/accounts/${accountId}/documents/extract`,
      }),
      providesTags: (result, _error, accountId) =>
        result
          ? [
              ...result.map((output) => ({
                type: 'ModelOutputs' as const,
                id: output.references?.documentId,
              })),
              { type: 'ModelOutputs' as const, id: accountId },
            ]
          : [{ type: 'ModelOutputs' as const, id: accountId }],
    }),
    requestAccountDocumentExtraction: build.mutation<any, { accountId: string; documentType?: string }>({
      query: ({ accountId, documentType }) => ({
        url: `genai/accounts/${accountId}/documents/extract${documentType ? `?documentType=${documentType}` : ''}`,
        method: 'POST',
      }),
      invalidatesTags: (_result, _error, { accountId }) => [{ type: 'ModelOutputs', id: accountId }],
    }),
  }),
});

export const {
  useGetDocumentExtractQuery,
  useGetDocumentExtractsByAccountQuery,
  useRequestAccountDocumentExtractionMutation,
} = genaiApi;
